/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountActiveUserCount} from '../models/AccountActiveUserCount';
import type {Error} from '../models/Error';

export interface GetAccountActiveUser$Request {
    accountId: number;
}

export interface GetAccountActiveUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountActiveUserRequest = createAction<PayloadData<void, GetAccountActiveUser$Request>>('GET_ACCOUNT_ACTIVE_USER__GET_ACCOUNT_ACTIVE_USER__REQUEST');
export const getAccountActiveUserSuccess = createAction<PayloadData<AccountActiveUserCount, GetAccountActiveUser$Request>>('GET_ACCOUNT_ACTIVE_USER__GET_ACCOUNT_ACTIVE_USER__SUCCESS');
export const getAccountActiveUserFailure = createAction<PayloadData<Error, GetAccountActiveUser$Request, true>>('GET_ACCOUNT_ACTIVE_USER__GET_ACCOUNT_ACTIVE_USER__FAILURE');

export const getAccountActiveUserActions = [
    getAccountActiveUserRequest,
    getAccountActiveUserSuccess,
    getAccountActiveUserFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountActiveUser = (meta: GetAccountActiveUser$Request, config?: GetAccountActiveUser$Config) => {
    return {
        CALL_API: {
            types: getAccountActiveUserActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/active-users`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

